document.addEventListener('turbolinks:load', function () {
  // ¥ 開発環境での開発スピードを上げるため青木の開発環境でのみ
  // ¥ manage/app/javascript/packs内の本jsファイルを走らせない
  if ((location.href.includes('dev-manage-ssl.platta.jp') || location.href.includes('http://18.177.103.115:3004')) && !location.href.includes('?dev27aoki')) {
    console.log('dev環境 public.jsを使用');
    return;
  }

  const ERROR_MSG = 'エラー！ 処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;

  const DOMAIN = $('#pl_domain').val();

  let current_url = location.href;
  // uploadするファイルを保存する
  let file_for_update;
  let file_for_delete;

  //############################################################
  // ファイルを選択した時にファイル名を表示させる
  //############################################################
  $('.pdtupdate__upload_input').on('change', function () {
    file_for_update = $(this).prop('files')[0];
    $('.pdtupdate__upload_state_text').text(file_for_update.name);
  });

  $('.pdtupdate__delete_input').on('change', function () {
    file_for_delete = $(this).prop('files')[0];
    $('.pdtupdate__delete_state_text').text(file_for_delete.name);
  });

  //############################################################
  // csvファイルをrubyに送る処理
  //###########################################################
  const send_product_csv_data = function (form_id, uploaded_file_id) {
    let file_id = uploaded_file_id;
    let fileInput = $(file_id)[0];
    let file = fileInput.files[0];
    let filename = file.name;

    let account_id = Number($('#hidden_account_id').val());

    // Nokogiriを使って画像urlを取得するアカウント一覧
    const NOKOGIRI_ACCOUNT_IDS = [20, 21, 22, 10016, 10018, 10025];

    // Seleniumを使わないと画像urlを取得できないアカウント一覧
    const SELENIUM_ACCOUNT_IDS = [10, 10020];

    const MERGED_ACCOUNT_IDS = [...NOKOGIRI_ACCOUNT_IDS, ...SELENIUM_ACCOUNT_IDS];

    // スクレイピングで１行ごとに画像urlを取得にかかる秒数
    // (実際にかかる時間よりも少し多めに設定している)
    let seconds_per_line = NOKOGIRI_ACCOUNT_IDS.includes(account_id) ? 1.5 : 2.5;

    if (MERGED_ACCOUNT_IDS.includes(account_id)) {
      alert(
        `
        貴社webサイトから画像データを取得した後にデータが
        登録されるためしばらく時間がかかる場合がございます。

        登録されるまでにかかる時間(参考): 登録データ数(行) x ${seconds_per_line}秒

        本ページから離れてもデータの登録は継続されるので
        別ページに移動しても問題ございません。
        `
      );
    }

    let extension = filename.split('.').pop().toLowerCase();
    let allowedExtensions = ['csv'];

    if (!allowedExtensions.includes(extension)) {
      alert('Only CSV is allowed.');
      return;
    }

    let formData = new FormData();
    formData.append('file', file);

    // plattaMallにアカウントIDを共有する
    formData.append('account_id', account_id); // Append the account_id to the form data

    let target_url = '';

    if (location.href.includes('https://manage.platta.jp/product_update')) {
      // platta mallのurlにajaxを飛ばし、platta mallでスクレイピング及び本番のDBで登録処理を行う
      target_url = $(form_id).attr('action');
    } else if (location.href.includes('https://dev-manage-ssl.platta.jp/product_update') || location.href.includes('http://18.177.103.115:3002/product_update')) {
      // platta mallのurlにajaxを飛ばし、開発manageにてスクレイピング及び開発のDBで登録処理を行う
      target_url = $(form_id).data('action');
    } else {
      alert('本操作が許可されていないurlです。処理を停止します。');
      return;
    }

    $.ajax({
      // * 本番Manageではなく、plattaMallでスクレイピングの処理を行う manageの処理を軽くし、サーバーが止まらないようにするため
      // url: $(form_id).attr('action'), // /product_update_database
      url: target_url, // /product_update_database
      // url: 'https://test-platta-site.com/nokogiri_scraping',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      timeout: 1200000, // Timeout set to 20 minutes
      success: function (data) {
        if (data.is_db_changed_successfully === 'true') {
          alert('商品マスタの更新が完了しました。');
        } else if (data.is_db_changed_successfully == 'false') {
          alert(
            `商品マスタの読み込みに失敗しました。
          お客様の商品マスタの構成(列名)が変更された可能性がございます。
          修正の上、再度お試しください。`.replace(/[ \t]/g, '')
          );
        } else if (data.is_db_changed_successfully == 'productsNotFound') alert(`削除する対象の商品がありません。`.replace(/[ \t]/g, ''));
      },
      // ¥ 基本、画像urlをスクレイピングするコードでエラーが発生した場合のエラー表示
      error: function (jqXHR, textStatus, errorThrown) {
        console.error(jqXHR);
        // ¥ スクレイピングに時間がかかると自動でエラーが無くてもjsがエラーを返すため
        // ¥ その場合は alert()を出さないようにする
        if (jqXHR.status != 504 && jqXHR.status != 0) {
          alert(
            `予期せぬエラーが発生しました。お手数ですが、再度お試しください。
          エラーが継続する場合は、お手数ですが、弊社カスタマーサクセスまでお問い合わせください。`.replace(/[ \t]/g, '')
          );
        } else if (jqXHR.status == 0) {
          alert(
            `商品マスタを更新しています。
            本ページを離れても処理は継続し続けますのでご安心ください。
            ※更新するデータの数に応じて結果の反映に時間がかかる場合がございます。
            '`.replace(/[ \t]/g, '')
          );
        }
        console.log('jqXHR.textStatus', typeof jqXHR.status);
      },
      complete: function () {
        if (uploaded_file_id === '#file_update') {
          $('#pdtupdate__upload_btn').css({ 'pointer-events': 'auto' }, { 'background-color': '#4169e1' });
        } else if (uploaded_file_id === '#file_delete') {
          $('#pdtupdate__delete_btn').css({ 'pointer-events': 'auto' }, { 'background-color': 'red' });
        }
        return 'done';
      },
    });
  };

  //############################################################
  // csv or excelファイルのデータをrubyにわたす処理 DBの新規登録 + 更新
  //############################################################
  $('#pdtupdate__upload_btn')
    .off('click')
    .on('click', function (e) {
      e.preventDefault();
      if (!file_for_update) {
        alert('ファイルが選択されていません。');
        return;
      }
      confirm_yes_or_no = confirm(
        `この操作には時間がかかる場合がございます。本ページから離れても処理は継続されるので問題ございません。

      本操作は実行後、取り消せません。実行しますか?
      注) 商品マスタの構成(列名)が変更されているとデータを正しく取り込めないことがございます。`.replace(/[ \t]/g, '')
      );
      if (confirm_yes_or_no) {
        $('#pdtupdate__update_btn').css({ 'pointer-events': 'none', 'background-color': 'gray' });
        send_product_csv_data('#product-update-form', '#file_update');
        // 選択済みのファイルを削除する
        $('#file_update').val('');
        file_for_update = null;
        setTimeout(() => {
          $('.pdtupdate__upload_state_text').text('選択されていません');
        }, 1000);
      } else {
      }
    });

  //############################################################
  // csv or excelファイルのデータをrubyにわたす処理 DB 一括削除
  //############################################################
  $('#pdtupdate__delete_btn')
    .off('click')
    .on('click', function (e) {
      e.preventDefault();
      if (!file_for_delete) {
        alert('ファイルが選択されていません。');
        return;
      }
      confirm_yes_or_no = confirm(
        `この操作には時間がかかる場合がございます。本ページから離れても処理は継続されるので問題ございません。

      本操作は実行後、取り消せません。実行しますか?`.replace(/[ \t]/g, '')
      );
      if (confirm_yes_or_no) {
        $('#pdtupdate__delete_btn').css({ 'pointer-events': 'none', 'background-color': 'gray' });
        send_product_csv_data('#product-delete-form', '#file_delete');
        // 選択済みのファイルを削除する
        $('#file_delete').val('');
        file_for_delete = null;
        setTimeout(() => {
          $('.pdtupdate__delete_state_text').text('選択されていません');
        }, 1000);
      } else {
        // console.log('キャンセルしました。');
      }
    });

  //############################################################
  // ファイルをダウンロードしたときのファイル名に現在時刻を拡張子の前につける
  //############################################################
  const time_now_as_YYYYMMDDHHMMSS = function () {
    let date = new Date();
    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are 0-based in JavaScript
    let day = ('0' + date.getDate()).slice(-2);
    let hours = ('0' + date.getHours()).slice(-2);
    let minutes = ('0' + date.getMinutes()).slice(-2);
    let seconds = ('0' + date.getSeconds()).slice(-2);

    let time_now = year + month + day + hours + minutes + seconds;

    // console.log('time_now: ', time_now); // Prints the current time formatted as 'YYYYMMDDHHMMSS'

    return time_now;
  };

  //############################################################
  // csv ファイルをダウンロードする処理 (/i/products_setting.html.erb)の要素をクリック
  //############################################################
  $('.pu_csv_download_btn')
    .off('click')
    .on('click', function () {
      $('.pu_csv_download_btn').css({ 'pointer-events': 'none', 'background-color': 'gray' });
      $.ajax({
        url: '/pu_download_csv_file',
        type: 'GET',
        data: {
          no_data: 'no_data',
        },
        // dataType: 'json',
        dataType: 'text', // <-- change this from 'json' to 'text'
      })
        .done(function (data) {
          // ¥ 改行を残してそれ以外の不要な空白を削除する
          alert(`CSVファイルのダウンロードを開始します。`.replace(/[ \t]/g, ''));
          // ajaxを通じてcsvダウンロードはできないため下記のようにしてcsvファイルをブラウザでダウンロードさせる
          let blob = new Blob([data], { type: 'text/csv' });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          // ファイル名
          a.download = `商品マスタ登録アイテム一覧_${time_now_as_YYYYMMDDHHMMSS()}.csv`;
          a.click();
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.log('errorThrown');
          console.log('jqXHR, textStatus, errorThrow', jqXHR, textStatus, errorThrown);
          alert('csvのダウンロードに失敗しました。お手数ですが、弊社カスタマーサクセスまでお問い合わせください。');
        })
        .always(function () {
          // location.reload();
          $('.pu_csv_download_btn').css({ 'pointer-events': 'auto', 'background-color': 'orange' });
        });
    });
});
